const cartToken = () => {
    return {
        set: (Key) => {
            localStorage.setItem('cart_token', Key)
            return Key
        },
        get: () => {
            return localStorage.getItem('cart_token')
        },
        new: async () => {
            const newKey = genKeyRandom()
            localStorage.setItem('cart_token', newKey)
            return newKey
        },
        remove: () => {
            localStorage.removeItem('cart_token')
        }
    }
}
const draftStorage = () => {
    return {
        add: (order) => {
            localStorage.setItem('draft_storage', JSON.stringify(order))
            let setDraft = JSON.parse(localStorage.getItem('draft_storage'))
            return setDraft
        },
        get: () => {
            const draft = JSON.parse(localStorage.getItem('draft_storage'))  
            return draft ? draft : {}
        },
    }
}
const dateFirstDraft = () => {
    return {
        add: (date) => {
            localStorage.setItem('date_first_draft', JSON.stringify(date))
        },
        get: () => {
            return JSON.parse(localStorage.getItem('date_first_draft'))  
        },
        remove: () => {
            
        }
    }
}
const senderStorage = () => {
    return {
        add: (sender) => {
            localStorage.setItem('sender_storage', JSON.stringify(sender))
        },
        getid: (shopId,key) => {
            const setSender = JSON.parse(localStorage.getItem('sender_storage'))
            return setSender[shopId].find((val) => val === key)
        },
        get: () => {
            return JSON.parse(localStorage.getItem('sender_storage'))
        },
        remove: () => {
            // let setSender = JSON.parse(localStorage.getItem('sender_storage'))
            
        }
    }
}
const removeDraft = (shopId, key) => {
    let senderAll = senderStorage().get()
    let draftAll = draftStorage().get()
    let dateFirst = dateFirstDraft().get()
    if (senderAll && senderAll[shopId])
    delete senderAll[shopId][key]
    if (draftAll && draftAll[shopId])
    delete draftAll[shopId][key]
    if (dateFirst && dateFirst[shopId])
    delete dateFirst[shopId][key]
    senderStorage().add(senderAll)
    draftStorage().add(draftAll)
    dateFirstDraft().add(dateFirst)
}
const genKeyRandom = (length = 10) => {
    let result           = '';
    let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}
export default {
    cartToken,
    draftStorage,
    removeDraft,
    genKeyRandom,
    senderStorage,
    dateFirstDraft
}
